import React, { useState } from "react";
import SimpleFormDialog, { SimpleFormLabel } from 'components/dialogs/SimpleFormDialog';
import { useTranslation } from "react-i18next";
import { QueryFieldsSelector } from "components/queries/queryBuilder/dialogParts/QueryFieldsSelector";
import { QueryFieldSelector } from "components/queries/queryBuilder/dialogParts/QueryFieldSelector";
import { AutoWidgetQueryBehavior, getSingleOriginalRequestByName, WidgetRequest } from "system/widget/Widget";
import { WidgetSettingsProps } from "components/widgetParts/WidgetSettingsWrapper";
import { Paper } from "@mui/material";

const defaultWidgetRequest = {
  name: 'ai-summary',
  endpoint: 'query/test',
  queryParams: { },
  autoWidgetQueryBehavior: AutoWidgetQueryBehavior.AUTO_SINGLE
} as WidgetRequest;


export function BuildDefaultAISummaryRequests(): WidgetRequest[] | undefined  {
  const widgetRequest : WidgetRequest = { ...defaultWidgetRequest, requestInit: { body: {} } };
  return [widgetRequest];
}

export default function AISummarySettings(props: WidgetSettingsProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const originalRequest = getSingleOriginalRequestByName(props.activeWidgetRequests, 'ai-summary');
  const requestBody = originalRequest?.requestInit?.body || {};

  const [selectedFieldIds, setSelectedFieldIds] = useState<string[]>(requestBody?.summary?.fields || []);
  const [timestampFieldId, setTimestampFieldId] = useState<string>(requestBody?.summary?.timestamp_field || null);

  const updateWidgetData = () => {
    if (props.widget?.id && props.onUpdateWidgetData) {
      props.onUpdateWidgetData(props.widget?.id, {
        ...props.widget.data,
      });
    }
  }

  const updateRequest = () => {
    const widgetRequest : WidgetRequest = { ...defaultWidgetRequest, requestInit: { body: {} } };
    const requestInitBody = { summary: {} };

    if (selectedFieldIds?.length > 0) {
      requestInitBody.summary.fields = selectedFieldIds;
    }
    if (timestampFieldId?.length > 0) {
      requestInitBody.summary.timestamp_field = timestampFieldId;
    }
    widgetRequest.requestInit = { body: requestInitBody };
    props.saveWidgetRequests([widgetRequest]);
  }

  return (
    <>
      <SimpleFormDialog
        title={i18n.t("widget-types.ai-summary.settings.title")}
        isOpen={true}
        onCancel={() => props.setSettingsDialogIsOpen(false)}
        onConfirm={() => {
          updateRequest();
          updateWidgetData();
          props.setSettingsDialogIsOpen(false);
        }}>
        <Paper sx={{ p: 2, pt: 0.5 }}>
        {props.queryInfo && (<>
          <SimpleFormLabel>{i18n.t("fields-to-analyze")}</SimpleFormLabel>
          <QueryFieldsSelector
            allowedFieldTypes={["text"]}
            selectedFieldIds={selectedFieldIds}
            setSelectedFieldIds={(newFieldIds: string[]) => {
              setSelectedFieldIds(newFieldIds);
            }}
            queryInfo={props.queryInfo}
            requireAggSupported={true}
            placeholder={i18n.t("using-dataset-defaults")}
          />

          <SimpleFormLabel>{i18n.t("datetime-field")}</SimpleFormLabel>
          <QueryFieldSelector
            allowedFieldTypes={["timestamp"]}
            selectedFieldId={timestampFieldId}
            setSelectedFieldId={(newFieldId: string) => {
              setTimestampFieldId(newFieldId);
            }}
            fields={props.queryInfo.fields}
            placeholder={i18n.t("using-dataset-defaults")}
          />
        </>)}
        </Paper>
      </SimpleFormDialog>
    </>
  );
}
